import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/Bottom/styles/bottom.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/Bottom/styles/Form.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/app/src/app/_components/Form/Form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/ReactMenu/ClientMenu/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/ReactMenu/MobileMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/ReactMenu/sticky.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/app/providers.tsx");
